/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Privacy_TitleInputs */

const de_account_privacy_title = /** @type {(inputs: Account_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

/** @type {(inputs: Account_Privacy_TitleInputs) => LocalizedString} */
const en_account_privacy_title = de_account_privacy_title;

/**

* @param {Account_Privacy_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_privacy_title = /** @type {((inputs?: Account_Privacy_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Privacy_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_privacy_title(inputs)
	return en_account_privacy_title(inputs)
});